import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=4db8980e&scoped=true"
import script from "./CardCarousel.vue?vue&type=script&lang=ts"
export * from "./CardCarousel.vue?vue&type=script&lang=ts"
import style0 from "./CardCarousel.vue?vue&type=style&index=0&id=4db8980e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db8980e",
  null
  
)

export default component.exports